//React
import React from 'react';
import { IntlProvider } from 'react-intl';
import { intlFormats } from './intl';
// React router
import Router from 'react-router/lib/Router';
import browserHistory from 'react-router/lib/browserHistory';
import Api from './api';
import enMessages from './config/messages/en';
import style from './styles/style';
//Redux
import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import {
  syncHistoryWithStore,
  routerReducer,
  routerMiddleware
} from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();

import reducers from './reducers';
import routes from './router';
import { restoreUser } from './actions/auth';
import Messages from './components/Messages';

import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { generateMainTheme, themeFactory, BackOfficeThemeType } from './themes';
import thunk from 'redux-thunk';

import themeConfig from './themeConfig';


const reducer = combineReducers({
  ...reducers,
  routing: routerReducer,
  form: formReducer
});

const store = createStore(
  reducer,
  compose(
    applyMiddleware(thunk),
    applyMiddleware(routerMiddleware(browserHistory)),
    typeof window.devToolsExtension !== 'undefined'
      ? window.devToolsExtension()
      : f => f,
  ),
);

Api.store = store;

const history = syncHistoryWithStore(browserHistory, store);

const isFound = Object.keys(themeConfig).find(elem =>
  location.hostname.includes(elem),
);

const theme = isFound
  ? BackOfficeThemeType[themeConfig[isFound]]
  : BackOfficeThemeType.defaultTheme;

const SiteTheme = getMuiTheme(generateMainTheme(themeFactory(theme)));

class AppComponent extends React.Component {
  static childContextTypes = {
    muiTheme: React.PropTypes.object
  };

  getChildContext = () => {
    return {
      muiTheme: SiteTheme
    };
  };

  render() {
    const isStage = location.hostname.includes('stage')
    return (
      <MuiThemeProvider muiTheme={SiteTheme}>
        <IntlProvider locale="en" messages={enMessages} formats={intlFormats}>
          <Provider store={store}>
            <div className={isStage ? style.dev : ''}>
              <Router history={history} routes={routes(store)}></Router>
              <Messages />
            </div>
          </Provider>
        </IntlProvider>
      </MuiThemeProvider>
    );
  }
}

export const restore = function() {
  return store.dispatch(restoreUser(store.getState().auth.token));
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/App.jsx